import 'date-fns'
import React from 'react'
import {
  Typography,
  MuiLocalizationProvider,
  KeyboardDatePicker,
  Grid,
  MuiAdapterDateFns,
  TextField,
  TextFieldProps,
} from 'cs-kevlar-react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import { Spacing } from 'cs-kevlar-react/lib/es/theming/baseConstants'

interface ReportDateRangeModalProps {
  error: string | null
  startDate: Date | null
  endDate: Date | null
  onSelectStartDate: (date: Date | null) => void
  onSelectEndDate: (date: Date | null) => void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridItem: {
      width: '100%',
    },
    input: {
      minWidth: 0
    },
    inputError: {
      textAlign: 'center',
      marginTop: theme.spacing(8),
    },
  }),
)

export const ReportDateRange: React.FunctionComponent<ReportDateRangeModalProps> = ({
  error,
  startDate,
  endDate,
  onSelectStartDate,
  onSelectEndDate,
}) => {
  const classes = useStyles({})

  return (
    <MuiLocalizationProvider dateAdapter={MuiAdapterDateFns}>
      <Grid
        container
        spacing={Spacing}
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
      >
        <Grid item className={classes.gridItem}>
          <KeyboardDatePicker
            label="Start Date"
            inputFormat="MM/dd/yyyy"
            value={startDate}
            onChange={onSelectStartDate}
            renderInput={(params: TextFieldProps) => <TextField className={classes.input} {...params} />}
          />
        </Grid>
        <Grid item className={classes.gridItem}>
          <KeyboardDatePicker
            label="End Date"
            inputFormat="MM/dd/yyyy"
            value={endDate}
            onChange={onSelectEndDate}
            renderInput={(params: TextFieldProps) => <TextField className={classes.input} {...params} />}
          />
        </Grid>
        {error !== null && (
          <Grid container>
            <Grid item xs={12} className={classes.inputError}>
              <Typography color="error">{error}</Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
    </MuiLocalizationProvider>
  );
}
